import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { color, space } from "styled-system"
import { ButtonsWrapper, H4 } from "./UIStyle/UIstyle"
import media from "styled-media-query"
import Button from "./Button"
import PopupGetNFT from "./PopupGetNFT"
import Countdown from "react-countdown"
import CountBar from "./CountBar"

import { theme } from "@/containers/LuckyBagNew2023/Views/mixin"

export default function MintButton({
  eventEnd,
  eventDay1Start,
  totalSupply,
  maxDailyMintAmount,
  minted,
  mintPeriod,
  loading,
  setLoading,
  total,
  days,
  hours,
  minutes,
  seconds,
  setShowPopup,
  setPopupContent,
  phoneNumber,
  dayS,
  dayE
}) {
  const [showResult, setShowResult] = useState(false)
  const [walletIdToken, setWalletIdToken] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [receiveErrorCode, setReceiveErrorCode] = useState(null)
  const [txHash, setTxHash] = useState(null)
  const [savePhoneNumber, setSavePhoneNumber] = useState()

  const rendererCountBar = ({ total, days, hours, minutes, seconds }) => {
    return (
      <CountBar
        total={total}
        days={days}
        hours={hours}
        minutes={minutes}
        seconds={seconds}
        dayS={dayS}
        dayE={dayE}
      />
    )
  }

  const rendererButton = ({ total, days, hours, minutes, seconds }) => {
    return (
      <>
        {total ? (
          receiveErrorCode !== 4016 ? (
            <Button
              className="hover"
              onClick={onClickHolder}
              content="立刻免費領取 !"
              id="toybox-HeroButton"
            />
          ) : (
            <Button
              className="hover"
              onClick={onClickHolder}
              content="已領完，感謝參與 !"
              id="toybox-HeroButton"
              secondary
              disable
            />
          )
        ) : (
          <Button secondary disable content={<div>活動結束，感謝參與</div>} />
        )}
      </>
    )
  }
  useEffect(() => {
    if (typeof window !== undefined && window?.kryptogo_wallet?.id_token) {
      setWalletIdToken(window?.kryptogo_wallet?.id_token)
    }
  }, [])

  const handleClick = async (walletIdToken, phoneNumber = null) => {
    // 判斷手機號碼是否符合格式
    const phone_number = phoneNumber?.toString().startsWith("8860")
      ? `+886${phoneNumber.slice(4)}`
      : `+${phoneNumber}`

    const fetchBody = {
      event_id: `${process.env.NEXT_PUBLIC_NFT_TOYBOX}`,
      ...(!walletIdToken && { phone_number })
    }

    !walletIdToken && setShowPopup("send")
    setTimeout(() => {
      setShowPopup("loading")
    }, 2000)
    setIsLoading(true)

    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BACKEND_BASEURL}/airdrop/receive`,
        {
          method: "POST",
          body: JSON.stringify(fetchBody),
          ...(walletIdToken && {
            headers: new Headers({
              "KG-WALLET-TOKEN": walletIdToken
            })
          })
        }
      ).then(res => res.json())
      setIsLoading(false)
      if (response?.code === 0 || response?.code === 4006)
        setTxHash(response?.data.tx_hash)
      if (response?.code !== 0) setReceiveErrorCode(response?.code)
      if (response?.code === 0) setReceiveErrorCode(null)
    } catch (error) {
      setIsLoading(false)
      setReceiveErrorCode(error?.response?.code)
    }
    setTimeout(() => {
      setShowPopup("result")
    }, 2500)
    setShowResult(true)
  }

  const onClickHolder = () => {
    setShowPopup("open")
    setPopupContent(
      <PopupGetNFT
        setShowPanel={setShowPopup}
        showResult={showResult}
        setShowResult={setShowResult}
        isLoading={isLoading}
        receiveErrorCode={receiveErrorCode}
        handleClick={handleClick}
        txHash={txHash}
        walletIdToken={walletIdToken}
        savePhoneNumber={savePhoneNumber}
        setSavePhoneNumber={setSavePhoneNumber}
      />
    )
  }

  useEffect(() => {
    setPopupContent(
      <PopupGetNFT
        setShowPopup={setShowPopup}
        showResult={showResult}
        setShowResult={setShowResult}
        isLoading={isLoading}
        receiveErrorCode={receiveErrorCode}
        handleClick={handleClick}
        txHash={txHash}
        walletIdToken={walletIdToken}
        savePhoneNumber={savePhoneNumber}
        setSavePhoneNumber={setSavePhoneNumber}
      />
    )
  }, [showResult])

  return (
    <ButtonsWrapper>
      {/* ===================這邊是領取 Button */}
      {total ? (
        <ButtonWrapper
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Button content={<div>活動即將開始</div>} secondary disable />
        </ButtonWrapper>
      ) : (
        // 這邊是可以領取
        <Countdown date={dayE} renderer={rendererButton} />
      )}

      {/* ===================這邊是CountBar */}
      {!total ? (
        <Countdown date={dayE} renderer={rendererCountBar} />
      ) : (
        <H4>
          倒數{days}天{hours}小時{minutes}分鐘{seconds}秒
        </H4>
      )}
    </ButtonsWrapper>
  )
}

const DisabledButton = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 16px 32px;
  border-radius: 99999px;
  font-size: 24px;
  font-weight: bold;
  /* margin-top: 20px; */
  cursor: not-allowed;
  ${color};
  ${space};
  transition: 0.3s;

  ${media.lessThan("1440px")`
    font-size: 20px;
  `}

  ${media.lessThan("1024px")`
    padding: 18px 32px;
    // width: 50%;
    font-size: 20px;
  `}
  ${media.lessThan("600px")`
    font-size: 16px;
    padding: 12px;
    width: 100%;
  `}
`
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (${theme.md}) {
    width: 100%;
    max-width: 300px;
  }
  @media (${theme.sm}) {
    width: 100%;
    max-width: 300px;
  }
`
